import { createSlice, createSelector } from "@reduxjs/toolkit";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap, map, catchError } from "rxjs/operators";
import { casinoVIPStringPattern, sportVIPStringPattern, slotRacePageStringPattern, christmasTournamentStringPattern, landingRegistrationPagePattern, landingPageWithoutFooter, landingPageWithoutPromoSnackbar, landingPageWithoutHeader, landingPageWithoutMobileBottomMenu } from "@nxplatform/helpers/constants/text-page";
import { BasePromotionType } from "@nxplatform/platform-entities/bonuses/bonus-entities";
const TEXT_PAGES_FEATURE_KEY = "textPages";
var PromotionContentType = /* @__PURE__ */ ((PromotionContentType2) => {
  PromotionContentType2["base"] = "base";
  PromotionContentType2["race"] = "race";
  PromotionContentType2["christmasRace"] = "christmasRace";
  PromotionContentType2["promotion"] = "promotion";
  PromotionContentType2["vipProgram"] = "vipProgram";
  PromotionContentType2["sportVipProgram"] = "sportVipProgram";
  PromotionContentType2["landingRegistration"] = "landingRegistration";
  PromotionContentType2["prizeDrops"] = "prizeDrops";
  return PromotionContentType2;
})(PromotionContentType || {});
const initialTextPagesState = {
  loaded: false,
  title: null,
  content: null,
  promotion: null,
  sidebarMenu: null,
  tournamentId: null,
  error: null
};
const textPagesSlice = createSlice({
  name: TEXT_PAGES_FEATURE_KEY,
  initialState: initialTextPagesState,
  reducers: {
    getPageContentStart: (state) => {
      state.loaded = false;
    },
    getPageContentSuccess: (state, action) => {
      state.loaded = true;
      state.content = action.payload.renderedContent;
      if (!JSON.parse(JSON.stringify(state.sidebarMenu))) {
        state.promotion = action.payload.promotion;
        state.sidebarMenu = action.payload.menu.sidebarItems;
      }
      if (action.payload.promotion) {
        state.tournamentId = action.payload.promotion.tournamentFrontendIdentifier;
      }
      state.title = action.payload.page.title;
    },
    getPageContentFailure: (state, action) => {
      state.error = action.payload;
    },
    clearPageContent: (state) => {
      state.content = initialTextPagesState.content;
      state.promotion = initialTextPagesState.promotion;
      state.sidebarMenu = initialTextPagesState.sidebarMenu;
      state.loaded = initialTextPagesState.loaded;
      state.error = initialTextPagesState.error;
      state.title = initialTextPagesState.title;
    }
  }
});
const textPagesReducer = textPagesSlice.reducer;
const {
  getPageContentStart,
  getPageContentSuccess,
  getPageContentFailure,
  clearPageContent
} = textPagesSlice.actions;
const getTextPagesState = (rootState) => rootState[TEXT_PAGES_FEATURE_KEY];
const selectTextPagesLoadedState = createSelector(
  getTextPagesState,
  (s) => s.loaded
);
const selectTextPageContent = createSelector(
  getTextPagesState,
  (s) => s.content
);
const selectTextPagesError = createSelector(
  getTextPagesState,
  (s) => s.error
);
const selectTextPagePromotion = createSelector(
  getTextPagesState,
  (s) => s.promotion
);
const selectTextPageType = createSelector(
  [selectTextPageContent, selectTextPagePromotion],
  (content, promotion) => {
    if (content) {
      if (content.indexOf(casinoVIPStringPattern) !== -1) {
        return "vipProgram";
      }
      if (content.indexOf(sportVIPStringPattern) !== -1) {
        return "sportVipProgram";
      }
      if (slotRacePageStringPattern.test(content)) {
        return "race";
      }
      if (content.indexOf(christmasTournamentStringPattern) !== -1) {
        return "christmasRace";
      }
      if (content.indexOf(landingRegistrationPagePattern) !== -1) {
        return "landingRegistration";
      }
      if ((promotion == null ? void 0 : promotion.promotionType) === BasePromotionType.prizeDrops) {
        return "prizeDrops";
      }
      if (promotion) {
        return "promotion";
      }
    }
    return "base";
  }
);
const selectTextPageWithoutFooter = createSelector(
  selectTextPageContent,
  (content) => {
    return content && content.indexOf(landingPageWithoutFooter) !== -1;
  }
);
const selectTextPageWithoutPromoSnackbar = createSelector(
  selectTextPageContent,
  (content) => {
    return content && content.indexOf(landingPageWithoutPromoSnackbar) !== -1;
  }
);
const selectTextPageWithoutHeader = createSelector(
  selectTextPageContent,
  (content) => {
    return content && content.indexOf(landingPageWithoutHeader) !== -1;
  }
);
const selectTextPageWithoutMobileBottomMenu = createSelector(
  selectTextPageContent,
  (content) => {
    return content && content.indexOf(landingPageWithoutMobileBottomMenu) !== -1;
  }
);
const selectTournamentId = createSelector(
  getTextPagesState,
  (s) => s.tournamentId
);
const selectTextPageSidebarMenu = createSelector(
  getTextPagesState,
  (s) => s.sidebarMenu
);
const selectTextPageTitle = createSelector(
  getTextPagesState,
  (s) => s.title
);
const fetchPageContentEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getPageContentStart.type),
  switchMap(
    (action) => Api.page.getPageContent(action.payload).pipe(
      map((data) => getPageContentSuccess(data)),
      catchError((err) => of(getPageContentFailure(err)))
    )
  )
);
const fetchPageContent = (pageUrl) => ({
  type: getPageContentStart.type,
  payload: pageUrl
});
export {
  PromotionContentType,
  TEXT_PAGES_FEATURE_KEY,
  clearPageContent,
  fetchPageContent,
  fetchPageContentEpic,
  getPageContentFailure,
  getPageContentStart,
  getPageContentSuccess,
  getTextPagesState,
  initialTextPagesState,
  selectTextPageContent,
  selectTextPagePromotion,
  selectTextPageSidebarMenu,
  selectTextPageTitle,
  selectTextPageType,
  selectTextPageWithoutFooter,
  selectTextPageWithoutHeader,
  selectTextPageWithoutMobileBottomMenu,
  selectTextPageWithoutPromoSnackbar,
  selectTextPagesError,
  selectTextPagesLoadedState,
  selectTournamentId,
  textPagesReducer,
  textPagesSlice
};
